// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.classification-label {
  background: var(--page-bg);
  /* No height here: the page fills what the shell has left (.lf-fill-viewport
     in responsive.css). It used to subtract a guessed 90px of chrome from
     100vh, which is 15px short of the real header + container padding, so the
     studio ended up taller than the screen. */
  padding: 0.5rem 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.classification-label > .col-md-12 {
  flex: 0 0 auto;
  width: 100%;
}
.classification-label .page-header {
  height: 44px;
  display: flex;
  align-items: center;
  margin: 0;
}
.classification-label .page-header-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1rem 1.25rem;
  background: var(--card);
  border-radius: var(--radius);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  margin-bottom: 0.5rem;
}
.classification-label .page-header-title h5 {
  margin: 0;
  font-weight: 600;
  font-size: 1.15rem;
  color: var(--foreground);
}
.classification-label .page-header-title .btn-primary {
  background: var(--primary);
  border-color: var(--primary);
  color: var(--primary-foreground);
}
.classification-label .page-header-title .btn-primary:hover {
  background: var(--primary-hover);
  border-color: var(--primary-hover);
}
.classification-label .main-content {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-wrap: nowrap;
  gap: 0.75rem;
  overflow: hidden;
}
.classification-label .left-col,
.classification-label .right-col {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 1rem;
  overflow-y: auto;
  background: var(--card) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
}
.classification-label .center-col {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.classification-label .center-col .content-top-classification {
  flex: 0 1 auto;
  margin: 0;
  padding: 1rem;
  overflow-y: auto;
  background: var(--card) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
}
.classification-label .center-col .content-bottom-classification {
  flex: 1 1;
  min-height: 0;
  margin: 0;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background: var(--page-bg-subtle) !important;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
}
@media (max-width: 768px) {
  .classification-label .row {
    flex-direction: column;
    height: auto;
  }
  .classification-label .center-col {
    flex: unset;
  }
  .classification-label .center-col .content-top,
  .classification-label .center-col .content-bottom {
    flex: unset;
    max-height: none;
  }
}

/* Selection controls – theme variables */
.selection-controls {
  padding: 0.5rem 1rem;
  background: var(--muted);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  gap: 1rem;
  border-radius: var(--radius-sm);
}

.selection-controls button {
  padding: 0.25rem 0.5rem;
  background: var(--secondary);
  color: var(--secondary-foreground);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-size: 0.8rem;
  transition: background var(--transition-fast), border-color var(--transition-fast);
}

.selection-controls button:hover:not(:disabled) {
  background: var(--accent);
  border-color: var(--primary);
}

.selection-controls button:disabled {
  background: var(--muted);
  color: var(--muted-foreground);
  cursor: not-allowed;
}

.selection-controls .delete-button {
  background: var(--destructive);
  color: var(--destructive-foreground);
  border-color: var(--destructive);
}

.selection-controls .delete-button:hover:not(:disabled) {
  background: var(--destructive-hover);
  border-color: var(--destructive-hover);
}

.image-item {
  position: relative;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.image-item.multi-selected {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px var(--ring);
}

.selection-badge {
  position: absolute;
  top: 0 !important;
  right: 0 !important;
  background: var(--primary);
  color: var(--primary-foreground);
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: bold;
  z-index: 2;
}

.delete-image-btn {
  position: absolute;
  top: 2px;
  right: 2px;
  background: var(--destructive);
  color: var(--destructive-foreground);
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.9rem;
  cursor: pointer;
  opacity: 0;
  transition: opacity var(--transition);
  z-index: 3;
}

.delete-image-btn.visible {
  opacity: 1;
}

.delete-image-btn:hover {
  background: var(--destructive-hover);
}

.bulk-assign {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px dashed var(--border);
  width: 100%;
}

.class-button.bulk {
  background: var(--primary);
  color: var(--primary-foreground);
}

.class-button.bulk:hover {
  background: var(--primary-hover);
}

.selection-box {
  position: absolute;
  border: 2px dashed var(--primary);
  background: var(--primary-soft);
  pointer-events: none;
  z-index: 10;
}

/* Class images section */
.class-images .image-item {
  margin-bottom: 0.5rem;
}

/* Instructions */
.instructions {
  margin-top: 1rem;
  padding: 0.75rem;
  background: var(--muted);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 0.8rem;
  color: var(--foreground);
}

.instructions h4 {
  margin: 0 0 0.5rem 0;
  color: var(--foreground);
}

.instructions ul {
  margin: 0;
  padding-left: 1rem;
}

.class-setup {
  padding: 1rem;
  background: var(--card);
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: center;
}

.input-group label {
  font-weight: 600;
  color: var(--foreground);
}

.input-group input {
  padding: 0.5rem;
  border: 1px solid var(--input);
  border-radius: var(--radius-sm);
  width: 80px;
  background: var(--card);
  color: var(--foreground);
}

.unstructured-section,
.classes-section {
  padding: 1rem;
  overflow: auto;
  background: transparent;
}

.unstructured-section.drag-over {
  background: var(--accent);
  border: 2px dashed var(--primary);
  color: var(--foreground);
}

.unstructured-section.drag-over p {
  color: var(--foreground);
}

.unstructured-section.drag-over b {
  color: var(--primary) !important;
}

.preview-section {
  position: relative;
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0;
  overflow: hidden;
}

.classes-section {
  flex: 1 1;
  min-height: 200px;
}

.upload-options {
  text-align: center;
  margin-bottom: 1rem;
  padding: 1.25rem;
  border: 2px dashed var(--border);
  border-radius: var(--radius);
  background: var(--muted);
  transition: border-color var(--transition), background var(--transition);
}

.upload-options:hover {
  border-color: var(--primary);
  background: var(--accent);
}

/* Modifier keys are invisible affordances -- nobody discovers Ctrl+click on their
   own, so the grid says so once, quietly, above it. */
.selection-hint {
  margin: 0.4rem 0 0;
  font-size: 0.72rem;
  line-height: 1.5;
  color: var(--muted-foreground);
}
.selection-hint b {
  display: inline-block;
  padding: 0 0.25rem;
  border: 1px solid var(--border);
  border-radius: 3px;
  background: var(--background);
  color: var(--foreground);
  font-weight: 600;
  font-size: 0.68rem;
}

.upload-button {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: var(--primary);
  color: var(--primary-foreground);
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  margin-bottom: 0.5rem;
  transition: background var(--transition), box-shadow var(--transition);
}

.upload-button:hover {
  background: var(--primary-hover);
  box-shadow: var(--shadow-glow);
}

.upload-button.small {
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
}

.image-grid,
.class-images {
  display: grid;
  gap: 0.5rem;
}

.image-grid {
  grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));
}

.classes-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.class-block {
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 1rem;
  background: var(--card);
  box-shadow: var(--shadow-sm);
  transition: border-color var(--transition), box-shadow var(--transition);
}

.class-block:hover {
  border-color: var(--primary);
}

.class-block.drag-over {
  background: var(--accent);
  border: 2px dashed var(--primary);
  color: var(--foreground);
}

.class-block.drag-over p {
  color: var(--foreground);
}

.class-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.class-name-input {
  flex: 1 1;
  padding: 0.5rem;
  border: 1px solid var(--input);
  border-radius: var(--radius-sm);
  font-weight: 600;
  margin-right: 0.5rem;
  background: var(--card);
  color: var(--foreground);
}

.class-images {
  grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));
  min-height: 100px;
}

.image-item {
  width: 72px;
  height: 72px;
  border: 2px solid var(--border);
  border-radius: var(--radius-sm);
  overflow: hidden;
  cursor: pointer;
  transition: border-color var(--transition), box-shadow var(--transition);
}

.image-item:hover {
  border-color: var(--primary);
}

.image-item.selected {
  border-color: var(--primary);
  box-shadow: 0 0 0 2px var(--ring);
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.5rem;
  background: var(--muted);
  border-radius: var(--radius-sm);
  color: var(--foreground);
}

.close-button {
  padding: 0.25rem 0.5rem;
  background: var(--destructive);
  color: var(--destructive-foreground);
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  font-size: 1.2rem;
  line-height: 1;
  transition: background var(--transition);
}

.close-button:hover {
  background: var(--destructive-hover);
}

.no-selection,
.no-classes {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: var(--muted-foreground);
  text-align: center;
}

.drop-hint {
  grid-column: 1/-1;
  text-align: center;
  padding: 1rem;
  color: var(--muted-foreground);
  font-style: italic;
}

@media (max-width: 1024px) {
  .main-content {
    flex-direction: column;
    height: auto;
  }
  .unstructured-section,
  .preview-section,
  .classes-section {
    min-height: 300px;
  }
}
/* Initial / empty state – friendly placeholder */
.initial-overlay {
  background: var(--card);
  border: 2px dashed var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-sm);
  padding: 2rem;
  overflow: auto;
  text-align: center;
  transition: border-color var(--transition), background var(--transition);
}

.initial-overlay:hover {
  border-color: var(--primary);
  background: var(--accent);
}

.initial-overlay h2 {
  color: var(--muted-foreground);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 0.75rem 0;
}

.initial-overlay .no-classes {
  color: var(--muted-foreground);
  font-size: 0.95rem;
  padding: 0.5rem 0;
}

.initial-overlay .no-classes p {
  margin: 0;
}

.class-label {
  font-size: 15px;
  color: var(--foreground);
}

/* Create Classes input group – theme styling */
.classification-label .input-group.m-t-10 {
  margin-top: 0.75rem;
  margin-bottom: 1rem;
}

.classification-label .input-group .form-control {
  border: 1px solid var(--input);
  background: var(--card);
  color: var(--foreground);
}

.classification-label .input-group-append .btn-primary {
  background: var(--primary);
  border-color: var(--primary);
  color: var(--primary-foreground);
}

.classification-label .input-group-append .btn-primary:hover {
  background: var(--primary-hover);
  border-color: var(--primary-hover);
}

/* Text primary accent (e.g. UNSTRUCTURED label) */
.text-primary {
  color: var(--primary) !important;
}

.upload-progress-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--overlay);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.upload-progress-container {
  background: var(--card);
  padding: 1.5rem;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-lg);
  text-align: center;
  min-width: 300px;
  color: var(--foreground);
}

.progress-bar {
  height: 20px;
  background: var(--muted);
  border-radius: var(--radius-full);
  overflow: hidden;
  margin: 10px 0;
}

.progress-fill {
  height: 100%;
  background: var(--primary);
  transition: width var(--transition-slow);
}

/* =====================================================================
   Image previewer (components/ImagePreviewer.jsx)
   The preview area is the panel, not the image: small images are scaled up
   to fill it instead of sitting in the middle at their native pixel size.
   ===================================================================== */
.lf-preview {
  position: relative;
  flex: 1 1;
  min-height: 0;
  width: 100%;
  overflow: hidden;
  border-radius: var(--radius);
}

.lf-preview__viewport {
  position: absolute;
  inset: 0;
  overflow: hidden;
  cursor: grab;
  touch-action: none;
  background-color: var(--page-bg-subtle);
  background-image: linear-gradient(45deg, var(--muted) 25%, transparent 25%), linear-gradient(-45deg, var(--muted) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, var(--muted) 75%), linear-gradient(-45deg, transparent 75%, var(--muted) 75%);
  background-size: 16px 16px;
  background-position: 0 0, 0 8px, 8px -8px, -8px 0;
}

.lf-preview__viewport[data-dragging=true] {
  cursor: grabbing;
}

.lf-preview__img {
  position: absolute;
  top: 0;
  left: 0;
  transform-origin: 0 0;
  max-width: none; /* the transform does the scaling, not the layout */
  -webkit-user-select: none;
          user-select: none;
  -webkit-user-drag: none;
}

.lf-preview__error {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: var(--muted-foreground);
  font-size: 0.85rem;
}

.lf-preview__error i {
  font-size: 1.75rem;
  color: var(--warning);
}

.lf-preview__chip {
  position: absolute;
  top: 0.6rem;
  left: 0.6rem;
  z-index: 3;
  pointer-events: none;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  max-width: calc(100% - 1.2rem);
  padding: 0.3rem 0.7rem;
  border-radius: var(--radius-full);
  background: var(--card);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  font-size: 0.75rem;
  color: var(--foreground);
}

.lf-preview__chip i {
  color: var(--muted-foreground);
}

.lf-preview__name {
  max-width: 24ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.lf-preview__dims {
  padding-left: 0.45rem;
  border-left: 1px solid var(--border);
  font-family: var(--font-mono);
  font-size: 0.7rem;
  color: var(--muted-foreground);
}

.lf-preview__controls {
  position: absolute;
  right: 0.6rem;
  bottom: 0.6rem;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: var(--radius);
  background: var(--card);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.lf-preview__controls > div {
  display: flex;
}

.lf-preview__controls .lf-zoom-readout {
  min-width: 3.25rem;
}

/* --- stacked layout on small screens -------------------------------- */
@media (max-width: 992px) {
  .classification-label {
    /* Stacked: the studio is allowed to flow and the page scrolls. The shell's
       flex-grow still fills the screen when there is less content than height. */
    height: auto;
    min-height: 0;
    overflow: visible;
  }
  .classification-label .main-content {
    flex-wrap: wrap;
    overflow: visible;
  }
  .classification-label .main-content > .center-col {
    flex: 1 1 100%;
    order: -1;
    min-height: 55vh;
  }
  .classification-label .main-content > .left-col,
  .classification-label .main-content > .right-col {
    flex: 1 1 100%;
    max-height: 45vh;
  }
}
/* =====================================================================
   Class bar (components/ClassificationMiddleTop.jsx)
   One chip per class carrying its shortcut key, an accent and its count,
   plus the labeling progress. Replaces the two stacked grids of
   btn-outline-* buttons that used to appear during multi-select.
   ===================================================================== */
.classification-label .lf-class-bar {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: 100%;
  text-align: left; /* the column carries Bootstrap's .text-center */
}

.classification-label .lf-class-bar__status {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.classification-label .lf-class-bar__progress {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
}

.classification-label .lf-class-bar__progress-label {
  flex-shrink: 0;
  font-size: 0.75rem;
  color: var(--muted-foreground);
  font-variant-numeric: tabular-nums;
}

.classification-label .lf-class-bar__progress-label strong {
  color: var(--foreground);
  font-weight: 600;
}

.classification-label .lf-class-bar__remaining {
  color: var(--muted-foreground);
}

.classification-label .lf-class-bar__progress-track {
  flex: 1 1;
  min-width: 0;
  height: 5px;
  border-radius: var(--radius-full);
  background: var(--muted);
  overflow: hidden;
}

.classification-label .lf-class-bar__progress-fill {
  display: block;
  height: 100%;
  border-radius: var(--radius-full);
  background: var(--primary);
  transition: width var(--transition);
}

.classification-label .lf-class-bar__bulk {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.25rem 0.5rem;
  border-radius: var(--radius-sm);
  background: var(--primary-soft);
}

.classification-label .lf-class-bar__bulk-count {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--primary);
}

.classification-label .lf-class-bar__bulk-hint {
  flex: 1 1;
  min-width: 0;
  font-size: 0.75rem;
  color: var(--muted-foreground);
}

.classification-label .lf-class-bar__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(150px, 100%), 1fr));
  gap: 0.4rem;
}

.classification-label .lf-class-chip {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
  padding: 0.45rem 0.6rem;
  border: 1px solid var(--border);
  border-left: 3px solid var(--class-accent, var(--primary));
  border-radius: var(--radius-sm);
  background: var(--card);
  color: var(--foreground);
  font-size: 0.8rem;
  text-align: left;
  cursor: pointer;
  transition: background var(--transition), border-color var(--transition), transform var(--transition-fast);
}

.classification-label .lf-class-chip:hover:not(:disabled) {
  background: var(--accent);
  border-color: var(--class-accent, var(--primary));
  transform: translateY(-1px);
}

.classification-label .lf-class-chip:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px var(--ring);
}

.classification-label .lf-class-chip:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.classification-label .lf-class-chip__key {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  background: var(--muted);
  color: var(--muted-foreground);
  font-family: var(--font-mono);
  font-size: 0.68rem;
  font-weight: 600;
}

.classification-label .lf-class-chip__name {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.classification-label .lf-class-chip__count {
  flex-shrink: 0;
  font-family: var(--font-mono);
  font-size: 0.7rem;
  color: var(--muted-foreground);
  font-variant-numeric: tabular-nums;
}

.classification-label .lf-class-bar--empty {
  flex-direction: row;
  align-items: center;
  gap: 0.65rem;
  padding: 0.5rem 0.25rem;
  color: var(--muted-foreground);
  font-size: 0.75rem;
}

.classification-label .lf-class-bar--empty > i {
  font-size: 1.1rem;
  color: var(--primary);
}

.classification-label .lf-class-bar--empty span {
  display: flex;
  flex-direction: column;
  line-height: 1.35;
}

.classification-label .lf-class-bar--empty strong {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--foreground);
}

/* ==========================================================================
   AI grouping — the classification studio's auto-label

   Sits under the class bar rather than floating, so the images it is about to
   move stay visible while the user reads what it will do.
   ========================================================================== */

.lf-class-bar__ai.is-on {
  color: var(--primary-foreground);
  background: var(--primary);
  border-color: var(--primary);
}

.auto-group-panel {
  margin: 0.5rem 0 0;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.auto-group-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid var(--border);
}

.auto-group-panel__title {
  display: inline-flex;
  align-items: center;
  gap: 0.4375rem;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--foreground);
}

.auto-group-panel__title i {
  color: var(--primary);
}

.auto-group-panel__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  font-size: 0.75rem;
  color: var(--muted-foreground);
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
}

.auto-group-panel__close:hover {
  color: var(--foreground);
  background: var(--secondary);
}

.auto-group-panel__body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem;
}

.auto-group-panel__lead {
  margin: 0;
  font-size: 0.8125rem;
  color: var(--foreground);
}

.auto-group-panel__hint {
  margin: 0;
  font-size: 0.6875rem;
  color: var(--muted-foreground);
}

.auto-group-panel__label {
  font-size: 0.6875rem;
  font-weight: 500;
  color: var(--muted-foreground);
}

.auto-group-panel__choices {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
}

.auto-group-panel__choice {
  padding: 0.25rem 0.625rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--foreground);
  background: var(--background);
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-full);
  cursor: pointer;
  transition: color var(--transition-fast), background var(--transition-fast),
    border-color var(--transition-fast);
}

.auto-group-panel__choice:hover:not(:disabled) {
  border-color: var(--primary);
}

.auto-group-panel__choice.is-on {
  color: var(--primary-foreground);
  background: var(--primary);
  border-color: var(--primary);
}

.auto-group-panel__choice:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.auto-group-panel__progress {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.6875rem;
  color: var(--muted-foreground);
}

.auto-group-panel__bar {
  height: 3px;
  overflow: hidden;
  background: var(--border);
  border-radius: var(--radius-full);
}

.auto-group-panel__fill {
  display: block;
  height: 100%;
  background: var(--primary);
  border-radius: var(--radius-full);
  transition: width var(--transition);
}

.auto-group-panel__error {
  margin: 0;
  padding: 0.375rem 0.5rem;
  font-size: 0.75rem;
  color: var(--destructive);
  background: var(--destructive-soft);
  border-radius: var(--radius);
}

.auto-group-panel__result {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  margin: 0;
  padding: 0.375rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--success);
  background: var(--secondary);
  border-radius: var(--radius);
}

.auto-group-panel__actions {
  display: flex;
  gap: 0.5rem;
}

.auto-group-panel__run,
.auto-group-panel__stop {
  display: inline-flex;
  align-items: center;
  gap: 0.4375rem;
  padding: 0.375rem 0.875rem;
  font-size: 0.8125rem;
  font-weight: 600;
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
}

.auto-group-panel__run {
  color: var(--primary-foreground);
  background: var(--primary);
}

.auto-group-panel__run:hover {
  background: var(--primary-hover);
}

.auto-group-panel__stop {
  color: var(--destructive-foreground);
  background: var(--destructive);
}
`, "",{"version":3,"sources":["webpack://./src/pages/management/labelManagement/classificationLabel/styles/classificationLabel.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B;;;8CAG4C;EAC5C,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,qBAAqB;EACrB,uBAAuB;EACvB,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;AACA;EACE,SAAW;EACX,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,cAAc;EACd,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;AAC9B;AACA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;;IAEE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,yCAAyC;AACzC;EACE,oBAAoB;EACpB,wBAAwB;EACxB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,kCAAkC;EAClC,+BAA+B;EAC/B,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,kFAAkF;AACpF;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,oBAAoB;EACpB,WAAW;AACb;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,+BAA+B;EAC/B,WAAW;EACX,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,wBAAwB;EACxB,wEAAwE;AAC1E;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;sDACsD;AACtD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,gCAAgC;EAChC,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,4BAA4B;EAC5B,wEAAwE;AAC1E;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,2DAA2D;EAC3D,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,wEAAwE;AAC1E;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,oCAAoC;EACpC,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;;;IAGE,iBAAiB;EACnB;AACF;AACA,iDAAiD;AACjD;EACE,uBAAuB;EACvB,gCAAgC;EAChC,4BAA4B;EAC5B,4BAA4B;EAC5B,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,wEAAwE;AAC1E;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA,kDAAkD;AAClD;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;;;;0EAI0E;AAC1E;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,8PAA8P;EAC9P,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,qBAAqB;EACrB,eAAe,EAAE,mDAAmD;EACpE,yBAAiB;UAAjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,sBAAsB;EACtB,iCAAiC;EACjC,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;EAC7B,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA,yEAAyE;AACzE;EACE;IACE;iFAC6E;IAC7E,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,SAAS;IACT,gBAAgB;EAClB;EACA;;IAEE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA;;;;;0EAK0E;AAC1E;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,gBAAgB,EAAE,gDAAgD;AACpE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iCAAiC;EACjC,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uEAAuE;EACvE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,0DAA0D;EAC1D,+BAA+B;EAC/B,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0GAA0G;AAC5G;;AAEA;EACE,yBAAyB;EACzB,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;;;;+EAK+E;;AAE/E;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,6BAA6B;EAC7B,sCAAsC;EACtC,iCAAiC;EACjC,eAAe;EACf;uCACqC;AACvC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;AAChC","sourcesContent":["@charset \"UTF-8\";\n.classification-label {\n  background: var(--page-bg);\n  /* No height here: the page fills what the shell has left (.lf-fill-viewport\n     in responsive.css). It used to subtract a guessed 90px of chrome from\n     100vh, which is 15px short of the real header + container padding, so the\n     studio ended up taller than the screen. */\n  padding: 0.5rem 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.classification-label > .col-md-12 {\n  flex: 0 0 auto;\n  width: 100%;\n}\n.classification-label .page-header {\n  height: 44px;\n  display: flex;\n  align-items: center;\n  margin: 0;\n}\n.classification-label .page-header-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  background: var(--card);\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  margin-bottom: 0.5rem;\n}\n.classification-label .page-header-title h5 {\n  margin: 0;\n  font-weight: 600;\n  font-size: 1.15rem;\n  color: var(--foreground);\n}\n.classification-label .page-header-title .btn-primary {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: var(--primary-foreground);\n}\n.classification-label .page-header-title .btn-primary:hover {\n  background: var(--primary-hover);\n  border-color: var(--primary-hover);\n}\n.classification-label .main-content {\n  flex: 1 1 0;\n  min-height: 0;\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0.75rem;\n  overflow: hidden;\n}\n.classification-label .left-col,\n.classification-label .right-col {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 1rem;\n  overflow-y: auto;\n  background: var(--card) !important;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n}\n.classification-label .center-col {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n.classification-label .center-col .content-top-classification {\n  flex: 0 1 auto;\n  margin: 0;\n  padding: 1rem;\n  overflow-y: auto;\n  background: var(--card) !important;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n}\n.classification-label .center-col .content-bottom-classification {\n  flex: 1;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  background: var(--page-bg-subtle) !important;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n}\n@media (max-width: 768px) {\n  .classification-label .row {\n    flex-direction: column;\n    height: auto;\n  }\n  .classification-label .center-col {\n    flex: unset;\n  }\n  .classification-label .center-col .content-top,\n  .classification-label .center-col .content-bottom {\n    flex: unset;\n    max-height: none;\n  }\n}\n\n/* Selection controls – theme variables */\n.selection-controls {\n  padding: 0.5rem 1rem;\n  background: var(--muted);\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  border-radius: var(--radius-sm);\n}\n\n.selection-controls button {\n  padding: 0.25rem 0.5rem;\n  background: var(--secondary);\n  color: var(--secondary-foreground);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-size: 0.8rem;\n  transition: background var(--transition-fast), border-color var(--transition-fast);\n}\n\n.selection-controls button:hover:not(:disabled) {\n  background: var(--accent);\n  border-color: var(--primary);\n}\n\n.selection-controls button:disabled {\n  background: var(--muted);\n  color: var(--muted-foreground);\n  cursor: not-allowed;\n}\n\n.selection-controls .delete-button {\n  background: var(--destructive);\n  color: var(--destructive-foreground);\n  border-color: var(--destructive);\n}\n\n.selection-controls .delete-button:hover:not(:disabled) {\n  background: var(--destructive-hover);\n  border-color: var(--destructive-hover);\n}\n\n.image-item {\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n}\n\n.image-item.multi-selected {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px var(--ring);\n}\n\n.selection-badge {\n  position: absolute;\n  top: 0 !important;\n  right: 0 !important;\n  background: var(--primary);\n  color: var(--primary-foreground);\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.7rem;\n  font-weight: bold;\n  z-index: 2;\n}\n\n.delete-image-btn {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  background: var(--destructive);\n  color: var(--destructive-foreground);\n  border: none;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.9rem;\n  cursor: pointer;\n  opacity: 0;\n  transition: opacity var(--transition);\n  z-index: 3;\n}\n\n.delete-image-btn.visible {\n  opacity: 1;\n}\n\n.delete-image-btn:hover {\n  background: var(--destructive-hover);\n}\n\n.bulk-assign {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px dashed var(--border);\n  width: 100%;\n}\n\n.class-button.bulk {\n  background: var(--primary);\n  color: var(--primary-foreground);\n}\n\n.class-button.bulk:hover {\n  background: var(--primary-hover);\n}\n\n.selection-box {\n  position: absolute;\n  border: 2px dashed var(--primary);\n  background: var(--primary-soft);\n  pointer-events: none;\n  z-index: 10;\n}\n\n/* Class images section */\n.class-images .image-item {\n  margin-bottom: 0.5rem;\n}\n\n/* Instructions */\n.instructions {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  background: var(--muted);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 0.8rem;\n  color: var(--foreground);\n}\n\n.instructions h4 {\n  margin: 0 0 0.5rem 0;\n  color: var(--foreground);\n}\n\n.instructions ul {\n  margin: 0;\n  padding-left: 1rem;\n}\n\n.class-setup {\n  padding: 1rem;\n  background: var(--card);\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  justify-content: center;\n}\n\n.input-group label {\n  font-weight: 600;\n  color: var(--foreground);\n}\n\n.input-group input {\n  padding: 0.5rem;\n  border: 1px solid var(--input);\n  border-radius: var(--radius-sm);\n  width: 80px;\n  background: var(--card);\n  color: var(--foreground);\n}\n\n.unstructured-section,\n.classes-section {\n  padding: 1rem;\n  overflow: auto;\n  background: transparent;\n}\n\n.unstructured-section.drag-over {\n  background: var(--accent);\n  border: 2px dashed var(--primary);\n  color: var(--foreground);\n}\n\n.unstructured-section.drag-over p {\n  color: var(--foreground);\n}\n\n.unstructured-section.drag-over b {\n  color: var(--primary) !important;\n}\n\n.preview-section {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n\n.classes-section {\n  flex: 1;\n  min-height: 200px;\n}\n\n.upload-options {\n  text-align: center;\n  margin-bottom: 1rem;\n  padding: 1.25rem;\n  border: 2px dashed var(--border);\n  border-radius: var(--radius);\n  background: var(--muted);\n  transition: border-color var(--transition), background var(--transition);\n}\n\n.upload-options:hover {\n  border-color: var(--primary);\n  background: var(--accent);\n}\n\n/* Modifier keys are invisible affordances -- nobody discovers Ctrl+click on their\n   own, so the grid says so once, quietly, above it. */\n.selection-hint {\n  margin: 0.4rem 0 0;\n  font-size: 0.72rem;\n  line-height: 1.5;\n  color: var(--muted-foreground);\n}\n.selection-hint b {\n  display: inline-block;\n  padding: 0 0.25rem;\n  border: 1px solid var(--border);\n  border-radius: 3px;\n  background: var(--background);\n  color: var(--foreground);\n  font-weight: 600;\n  font-size: 0.68rem;\n}\n\n.upload-button {\n  display: inline-block;\n  padding: 0.5rem 1rem;\n  background: var(--primary);\n  color: var(--primary-foreground);\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  margin-bottom: 0.5rem;\n  transition: background var(--transition), box-shadow var(--transition);\n}\n\n.upload-button:hover {\n  background: var(--primary-hover);\n  box-shadow: var(--shadow-glow);\n}\n\n.upload-button.small {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.8rem;\n}\n\n.image-grid,\n.class-images {\n  display: grid;\n  gap: 0.5rem;\n}\n\n.image-grid {\n  grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));\n}\n\n.classes-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.class-block {\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 1rem;\n  background: var(--card);\n  box-shadow: var(--shadow-sm);\n  transition: border-color var(--transition), box-shadow var(--transition);\n}\n\n.class-block:hover {\n  border-color: var(--primary);\n}\n\n.class-block.drag-over {\n  background: var(--accent);\n  border: 2px dashed var(--primary);\n  color: var(--foreground);\n}\n\n.class-block.drag-over p {\n  color: var(--foreground);\n}\n\n.class-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.5rem;\n}\n\n.class-name-input {\n  flex: 1;\n  padding: 0.5rem;\n  border: 1px solid var(--input);\n  border-radius: var(--radius-sm);\n  font-weight: 600;\n  margin-right: 0.5rem;\n  background: var(--card);\n  color: var(--foreground);\n}\n\n.class-images {\n  grid-template-columns: repeat(auto-fill, minmax(72px, 1fr));\n  min-height: 100px;\n}\n\n.image-item {\n  width: 72px;\n  height: 72px;\n  border: 2px solid var(--border);\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  cursor: pointer;\n  transition: border-color var(--transition), box-shadow var(--transition);\n}\n\n.image-item:hover {\n  border-color: var(--primary);\n}\n\n.image-item.selected {\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px var(--ring);\n}\n\n.image-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.image-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 0.5rem;\n  background: var(--muted);\n  border-radius: var(--radius-sm);\n  color: var(--foreground);\n}\n\n.close-button {\n  padding: 0.25rem 0.5rem;\n  background: var(--destructive);\n  color: var(--destructive-foreground);\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  font-size: 1.2rem;\n  line-height: 1;\n  transition: background var(--transition);\n}\n\n.close-button:hover {\n  background: var(--destructive-hover);\n}\n\n.no-selection,\n.no-classes {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  color: var(--muted-foreground);\n  text-align: center;\n}\n\n.drop-hint {\n  grid-column: 1/-1;\n  text-align: center;\n  padding: 1rem;\n  color: var(--muted-foreground);\n  font-style: italic;\n}\n\n@media (max-width: 1024px) {\n  .main-content {\n    flex-direction: column;\n    height: auto;\n  }\n  .unstructured-section,\n  .preview-section,\n  .classes-section {\n    min-height: 300px;\n  }\n}\n/* Initial / empty state – friendly placeholder */\n.initial-overlay {\n  background: var(--card);\n  border: 2px dashed var(--border);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-sm);\n  padding: 2rem;\n  overflow: auto;\n  text-align: center;\n  transition: border-color var(--transition), background var(--transition);\n}\n\n.initial-overlay:hover {\n  border-color: var(--primary);\n  background: var(--accent);\n}\n\n.initial-overlay h2 {\n  color: var(--muted-foreground);\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0 0 0.75rem 0;\n}\n\n.initial-overlay .no-classes {\n  color: var(--muted-foreground);\n  font-size: 0.95rem;\n  padding: 0.5rem 0;\n}\n\n.initial-overlay .no-classes p {\n  margin: 0;\n}\n\n.class-label {\n  font-size: 15px;\n  color: var(--foreground);\n}\n\n/* Create Classes input group – theme styling */\n.classification-label .input-group.m-t-10 {\n  margin-top: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.classification-label .input-group .form-control {\n  border: 1px solid var(--input);\n  background: var(--card);\n  color: var(--foreground);\n}\n\n.classification-label .input-group-append .btn-primary {\n  background: var(--primary);\n  border-color: var(--primary);\n  color: var(--primary-foreground);\n}\n\n.classification-label .input-group-append .btn-primary:hover {\n  background: var(--primary-hover);\n  border-color: var(--primary-hover);\n}\n\n/* Text primary accent (e.g. UNSTRUCTURED label) */\n.text-primary {\n  color: var(--primary) !important;\n}\n\n.upload-progress-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--overlay);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.upload-progress-container {\n  background: var(--card);\n  padding: 1.5rem;\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-lg);\n  text-align: center;\n  min-width: 300px;\n  color: var(--foreground);\n}\n\n.progress-bar {\n  height: 20px;\n  background: var(--muted);\n  border-radius: var(--radius-full);\n  overflow: hidden;\n  margin: 10px 0;\n}\n\n.progress-fill {\n  height: 100%;\n  background: var(--primary);\n  transition: width var(--transition-slow);\n}\n\n/* =====================================================================\n   Image previewer (components/ImagePreviewer.jsx)\n   The preview area is the panel, not the image: small images are scaled up\n   to fill it instead of sitting in the middle at their native pixel size.\n   ===================================================================== */\n.lf-preview {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n  overflow: hidden;\n  border-radius: var(--radius);\n}\n\n.lf-preview__viewport {\n  position: absolute;\n  inset: 0;\n  overflow: hidden;\n  cursor: grab;\n  touch-action: none;\n  background-color: var(--page-bg-subtle);\n  background-image: linear-gradient(45deg, var(--muted) 25%, transparent 25%), linear-gradient(-45deg, var(--muted) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, var(--muted) 75%), linear-gradient(-45deg, transparent 75%, var(--muted) 75%);\n  background-size: 16px 16px;\n  background-position: 0 0, 0 8px, 8px -8px, -8px 0;\n}\n\n.lf-preview__viewport[data-dragging=true] {\n  cursor: grabbing;\n}\n\n.lf-preview__img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  transform-origin: 0 0;\n  max-width: none; /* the transform does the scaling, not the layout */\n  user-select: none;\n  -webkit-user-drag: none;\n}\n\n.lf-preview__error {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: var(--muted-foreground);\n  font-size: 0.85rem;\n}\n\n.lf-preview__error i {\n  font-size: 1.75rem;\n  color: var(--warning);\n}\n\n.lf-preview__chip {\n  position: absolute;\n  top: 0.6rem;\n  left: 0.6rem;\n  z-index: 3;\n  pointer-events: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  max-width: calc(100% - 1.2rem);\n  padding: 0.3rem 0.7rem;\n  border-radius: var(--radius-full);\n  background: var(--card);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  font-size: 0.75rem;\n  color: var(--foreground);\n}\n\n.lf-preview__chip i {\n  color: var(--muted-foreground);\n}\n\n.lf-preview__name {\n  max-width: 24ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.lf-preview__dims {\n  padding-left: 0.45rem;\n  border-left: 1px solid var(--border);\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  color: var(--muted-foreground);\n}\n\n.lf-preview__controls {\n  position: absolute;\n  right: 0.6rem;\n  bottom: 0.6rem;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 3px;\n  border-radius: var(--radius);\n  background: var(--card);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.lf-preview__controls > div {\n  display: flex;\n}\n\n.lf-preview__controls .lf-zoom-readout {\n  min-width: 3.25rem;\n}\n\n/* --- stacked layout on small screens -------------------------------- */\n@media (max-width: 992px) {\n  .classification-label {\n    /* Stacked: the studio is allowed to flow and the page scrolls. The shell's\n       flex-grow still fills the screen when there is less content than height. */\n    height: auto;\n    min-height: 0;\n    overflow: visible;\n  }\n  .classification-label .main-content {\n    flex-wrap: wrap;\n    overflow: visible;\n  }\n  .classification-label .main-content > .center-col {\n    flex: 1 1 100%;\n    order: -1;\n    min-height: 55vh;\n  }\n  .classification-label .main-content > .left-col,\n  .classification-label .main-content > .right-col {\n    flex: 1 1 100%;\n    max-height: 45vh;\n  }\n}\n/* =====================================================================\n   Class bar (components/ClassificationMiddleTop.jsx)\n   One chip per class carrying its shortcut key, an accent and its count,\n   plus the labeling progress. Replaces the two stacked grids of\n   btn-outline-* buttons that used to appear during multi-select.\n   ===================================================================== */\n.classification-label .lf-class-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  width: 100%;\n  text-align: left; /* the column carries Bootstrap's .text-center */\n}\n\n.classification-label .lf-class-bar__status {\n  display: flex;\n  align-items: center;\n  min-height: 32px;\n}\n\n.classification-label .lf-class-bar__progress {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.classification-label .lf-class-bar__progress-label {\n  flex-shrink: 0;\n  font-size: 0.75rem;\n  color: var(--muted-foreground);\n  font-variant-numeric: tabular-nums;\n}\n\n.classification-label .lf-class-bar__progress-label strong {\n  color: var(--foreground);\n  font-weight: 600;\n}\n\n.classification-label .lf-class-bar__remaining {\n  color: var(--muted-foreground);\n}\n\n.classification-label .lf-class-bar__progress-track {\n  flex: 1;\n  min-width: 0;\n  height: 5px;\n  border-radius: var(--radius-full);\n  background: var(--muted);\n  overflow: hidden;\n}\n\n.classification-label .lf-class-bar__progress-fill {\n  display: block;\n  height: 100%;\n  border-radius: var(--radius-full);\n  background: var(--primary);\n  transition: width var(--transition);\n}\n\n.classification-label .lf-class-bar__bulk {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  width: 100%;\n  padding: 0.25rem 0.5rem;\n  border-radius: var(--radius-sm);\n  background: var(--primary-soft);\n}\n\n.classification-label .lf-class-bar__bulk-count {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--primary);\n}\n\n.classification-label .lf-class-bar__bulk-hint {\n  flex: 1;\n  min-width: 0;\n  font-size: 0.75rem;\n  color: var(--muted-foreground);\n}\n\n.classification-label .lf-class-bar__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(min(150px, 100%), 1fr));\n  gap: 0.4rem;\n}\n\n.classification-label .lf-class-chip {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n  padding: 0.45rem 0.6rem;\n  border: 1px solid var(--border);\n  border-left: 3px solid var(--class-accent, var(--primary));\n  border-radius: var(--radius-sm);\n  background: var(--card);\n  color: var(--foreground);\n  font-size: 0.8rem;\n  text-align: left;\n  cursor: pointer;\n  transition: background var(--transition), border-color var(--transition), transform var(--transition-fast);\n}\n\n.classification-label .lf-class-chip:hover:not(:disabled) {\n  background: var(--accent);\n  border-color: var(--class-accent, var(--primary));\n  transform: translateY(-1px);\n}\n\n.classification-label .lf-class-chip:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px var(--ring);\n}\n\n.classification-label .lf-class-chip:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.classification-label .lf-class-chip__key {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 4px;\n  background: var(--muted);\n  color: var(--muted-foreground);\n  font-family: var(--font-mono);\n  font-size: 0.68rem;\n  font-weight: 600;\n}\n\n.classification-label .lf-class-chip__name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.classification-label .lf-class-chip__count {\n  flex-shrink: 0;\n  font-family: var(--font-mono);\n  font-size: 0.7rem;\n  color: var(--muted-foreground);\n  font-variant-numeric: tabular-nums;\n}\n\n.classification-label .lf-class-bar--empty {\n  flex-direction: row;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.5rem 0.25rem;\n  color: var(--muted-foreground);\n  font-size: 0.75rem;\n}\n\n.classification-label .lf-class-bar--empty > i {\n  font-size: 1.1rem;\n  color: var(--primary);\n}\n\n.classification-label .lf-class-bar--empty span {\n  display: flex;\n  flex-direction: column;\n  line-height: 1.35;\n}\n\n.classification-label .lf-class-bar--empty strong {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--foreground);\n}\n\n/* ==========================================================================\n   AI grouping — the classification studio's auto-label\n\n   Sits under the class bar rather than floating, so the images it is about to\n   move stay visible while the user reads what it will do.\n   ========================================================================== */\n\n.lf-class-bar__ai.is-on {\n  color: var(--primary-foreground);\n  background: var(--primary);\n  border-color: var(--primary);\n}\n\n.auto-group-panel {\n  margin: 0.5rem 0 0;\n  background: var(--card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.auto-group-panel__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem 0.75rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.auto-group-panel__title {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4375rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--foreground);\n}\n\n.auto-group-panel__title i {\n  color: var(--primary);\n}\n\n.auto-group-panel__close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.5rem;\n  height: 1.5rem;\n  font-size: 0.75rem;\n  color: var(--muted-foreground);\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n}\n\n.auto-group-panel__close:hover {\n  color: var(--foreground);\n  background: var(--secondary);\n}\n\n.auto-group-panel__body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 0.75rem;\n}\n\n.auto-group-panel__lead {\n  margin: 0;\n  font-size: 0.8125rem;\n  color: var(--foreground);\n}\n\n.auto-group-panel__hint {\n  margin: 0;\n  font-size: 0.6875rem;\n  color: var(--muted-foreground);\n}\n\n.auto-group-panel__label {\n  font-size: 0.6875rem;\n  font-weight: 500;\n  color: var(--muted-foreground);\n}\n\n.auto-group-panel__choices {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.375rem;\n}\n\n.auto-group-panel__choice {\n  padding: 0.25rem 0.625rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--foreground);\n  background: var(--background);\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-full);\n  cursor: pointer;\n  transition: color var(--transition-fast), background var(--transition-fast),\n    border-color var(--transition-fast);\n}\n\n.auto-group-panel__choice:hover:not(:disabled) {\n  border-color: var(--primary);\n}\n\n.auto-group-panel__choice.is-on {\n  color: var(--primary-foreground);\n  background: var(--primary);\n  border-color: var(--primary);\n}\n\n.auto-group-panel__choice:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.auto-group-panel__progress {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.6875rem;\n  color: var(--muted-foreground);\n}\n\n.auto-group-panel__bar {\n  height: 3px;\n  overflow: hidden;\n  background: var(--border);\n  border-radius: var(--radius-full);\n}\n\n.auto-group-panel__fill {\n  display: block;\n  height: 100%;\n  background: var(--primary);\n  border-radius: var(--radius-full);\n  transition: width var(--transition);\n}\n\n.auto-group-panel__error {\n  margin: 0;\n  padding: 0.375rem 0.5rem;\n  font-size: 0.75rem;\n  color: var(--destructive);\n  background: var(--destructive-soft);\n  border-radius: var(--radius);\n}\n\n.auto-group-panel__result {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n  margin: 0;\n  padding: 0.375rem 0.5rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--success);\n  background: var(--secondary);\n  border-radius: var(--radius);\n}\n\n.auto-group-panel__actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.auto-group-panel__run,\n.auto-group-panel__stop {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4375rem;\n  padding: 0.375rem 0.875rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  border: none;\n  border-radius: var(--radius);\n  cursor: pointer;\n}\n\n.auto-group-panel__run {\n  color: var(--primary-foreground);\n  background: var(--primary);\n}\n\n.auto-group-panel__run:hover {\n  background: var(--primary-hover);\n}\n\n.auto-group-panel__stop {\n  color: var(--destructive-foreground);\n  background: var(--destructive);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
